import styled from "styled-components";
import { Icon } from '@material-ui/core';

export const Wrapper = styled.div<{ bg: string }>`
  display: flex;
  padding: 8px 48px 8px 12px;
  border-radius: 8px;
  gap: 12px;
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 9999999990;
  width: calc(100vw - 32px);
  background: ${props => props.bg};
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #fff;
`;

export const CloseIcon = styled(Icon)`
  display: flex;
  color: #fff;
  position: fixed;
  top: 20px;
  right: 20px;
  font-size: 16px;
`;